module.exports = __webpack_public_path__ + "assets/img/6f1f-aq.svg";